import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import TextArea from '../../componentes/formulario/TextArea';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import MiSelect from '../../componentes/formulario/MiSelect';
import { Alert } from '../../componentes/ui/Alert';
import Uplm from '../../componentes/formulario/Uplm/Uplm';
import Upls from '../../componentes/formulario/Upls/Upls';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ListaRel from '../../componentes/formulario/ListaRel/ListaRel';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie} from '../../helpers/helperApp';

function Provincias(props){

    const cookies = new Cookies();

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin } = useLogicForm();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");


    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{          
                    document.title = getTitle(confPantalla.config.trad, confPantalla.provincias.title);                              
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.provincias.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.provincias.hijo.estadoform);                            
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.provincias.padre.urls);
                                saveFormularioPrin(confPantalla.provincias.padre.modelform);
                                saveFormularioHijo(confPantalla.provincias.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.provincias.padre.urls, confPantalla.provincias.hijo.urls, confPantalla.provincias.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 
        
    },[confPantalla])
    


 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.provincias.section.titulo } icono={ confPantalla.provincias.section.icono } col={ confPantalla.provincias.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.provincias.section.wiki } >
                                        <Formulario 
                                                    estadoForm= { estadoFormPrin }
                                                    loading=    { loadReg ? true : false }
                                                    btnNew={ confPantalla.provincias.padre.btnform.new }
                                                    btnSave={ confPantalla.provincias.padre.btnform.save }
                                                    btnSaveAndNew={ confPantalla.provincias.padre.btnform.saveandnew }
                                                    btnDelete={ confPantalla.provincias.padre.btnform.delete }
                                                    btnClone={ confPantalla.provincias.padre.btnform.clone }
                                                    handleSubmit = { e => handleSubmitPrin(e, confPantalla.provincias.padre.urls, confPantalla.provincias.padre.modelform, confPantalla.provincias.padre.tabla, confPantalla.provincias.hijo.modelform, confPantalla.provincias.title) } 
                                                    formulario = { formularioPrin } 
                                                    resetForm = { e => resetFormPrin(confPantalla.provincias.padre.modelform, true, confPantalla.provincias.padre.tabla) }  
                                                    handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.provincias.padre.urls, confPantalla.provincias.padre.modelform, confPantalla.provincias.padre.tabla, confPantalla.provincias.title) } 
                                        >                                        
                                                    <FormRow clases="" >
                                                        
                                                        <FormInput                                                        
                                                            estadoForm= { estadoFormPrin }
                                                            value=      { formularioPrin.nom }
                                                            loading=    { loadReg ? true : false }
                                                            id=         { confPantalla.provincias.padre.controles.nom.id }   
                                                            type=       { confPantalla.provincias.padre.controles.nom.type }  
                                                            name=       { confPantalla.provincias.padre.controles.nom.name }   
                                                            label=      { confPantalla.provincias.padre.controles.nom.label }                                                       
                                                            placeholder={ confPantalla.provincias.padre.controles.nom.placeholder }    
                                                            col=        { confPantalla.provincias.padre.controles.nom.col } 
                                                            required=   { confPantalla.provincias.padre.controles.nom.required }
                                                            readonly=   { confPantalla.provincias.padre.controles.nom.readonly }                                                
                                                            disabled=   { confPantalla.provincias.padre.controles.nom.disabled }
                                                            change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                                            onBlur=     {null} 
                                                        />
                                                        <MiSelect  
                                                            estadoForm=  { estadoFormPrin }
                                                            val=         { formularioPrin.idpai  }   
                                                            loading=     { loadReg ? true : false }
                                                            id=          { confPantalla.provincias.padre.controles.pais.id }    
                                                            name=        { confPantalla.provincias.padre.controles.pais.name }   
                                                            label=       { confPantalla.provincias.padre.controles.pais.label }    
                                                            placeholder= { confPantalla.provincias.padre.controles.pais.placeholder }
                                                            col=         { confPantalla.provincias.padre.controles.pais.col } 
                                                            isClearable= { confPantalla.provincias.padre.controles.pais.isclearable }
                                                            isSearchable={ confPantalla.provincias.padre.controles.pais.issearchable }
                                                            dataType=    { confPantalla.provincias.padre.controles.pais.datatype }
                                                            data=        { confPantalla.provincias.padre.controles.pais.data }
                                                            required=    { confPantalla.provincias.padre.controles.pais.required } 
                                                            disabled=    { confPantalla.provincias.padre.controles.pais.disabled }
                                                            readOnly =   { confPantalla.provincias.padre.controles.pais.readonly }
                                                            disablethisid={confPantalla.provincias.padre.controles.pais.disablethisid}
                                                            formulario = { formularioPrin } 
                                                            change=      { handleSelectFormPrin }                                                    
                                                        />
                                                    </FormRow>                                                       
                                        </Formulario>
                                        <MiDataTable
                                            formulario={formularioPrin} 
                                            estadoForm= { estadoFormPrin }
                                            id={"provincias"}
                                            columnas={confPantalla.provincias.padre.datatable.columns}
                                            data={registrosPrin}
                                            buttons={confPantalla.provincias.padre.datatable.buttons}
                                            ordering={confPantalla.provincias.padre.datatable.ordering}
                                            order={confPantalla.provincias.padre.datatable.order}
                                            searching={confPantalla.provincias.padre.datatable.searching}
                                            paging={confPantalla.provincias.padre.datatable.paging}
                                            select={confPantalla.provincias.padre.datatable.select}
                                            pagelength={confPantalla.provincias.padre.datatable.pagelength}
                                            handleEditReg= { e => handleEditRegPrin(e, confPantalla.provincias.padre.urls, confPantalla.provincias.hijo.urls, confPantalla.provincias.padreshijos, confPantalla.provincias.hijo.modelform, confPantalla.provincias.padre.tabla) }
                                            handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.provincias.padre.urls, confPantalla.provincias.padre.modelform, confPantalla.provincias.padre.tabla, confPantalla.provincias.title) }
                                            saveLoadingTable={ saveLoadingTable }
                                            loadingTable={loadingTable}
                                            columnactions={confPantalla.provincias.padre.datatable.columnactions.title}
                                            traduction={confPantalla.config.trad.components.datatable}
                                        />                                             
                                                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Provincias